document.addEventListener("DOMContentLoaded", () => {

  const sections =
    document.querySelectorAll(".p-marcas-wrapper");


  sections.forEach(section => {

    const vendor =
      (section.dataset.brandVendor || "").trim();


    if (!vendor) {
      return;
    }


    const productsContainer =
      section.querySelector("[data-p-marcas-products]");


    const panel =
      section.querySelector("[data-p-marcas-panel]");


    const loading =
      section.querySelector("[data-p-marcas-loading]");


    const empty =
      section.querySelector("[data-p-marcas-empty]");


    const loadMoreWrap =
      section.querySelector("[data-p-marcas-load-more]");


    const loadMoreButton =
      section.querySelector("[data-p-marcas-load]");


    if (!productsContainer) {
      return;
    }


    let currentPage = 1;

    let hasMore = true;

    let isLoading = false;


    /* ======================================================
       CONSULTA
    ====================================================== */

    function buildSearchUrl(page) {

      const root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";


      /*
        Shopify storefront search soporta búsqueda por vendor:

        vendor:"Menthic"
        vendor:"Natural Amigos"
        vendor:"AM Mascotas"
      */

      const query =
        `vendor:"${vendor.replace(/"/g, '\\"')}"`;


      const params =
        new URLSearchParams();


      params.set("q", query);
      params.set("type", "product");
      params.set("page", page);
      params.set(
        "section_id",
        "p-marcas-results"
      );


      return (
        root +
        "search?" +
        params.toString()
      );

    }


    /* ======================================================
       CARGAR PRODUCTOS
    ====================================================== */

    async function loadProducts() {

      if (
        isLoading ||
        !hasMore
      ) {
        return;
      }


      isLoading = true;


      if (loadMoreButton) {
        loadMoreButton.disabled = true;
      }


      try {

        const response =
          await fetch(
            buildSearchUrl(currentPage),
            {
              headers: {
                "X-Requested-With": "XMLHttpRequest"
              }
            }
          );


        if (!response.ok) {
          throw new Error(
            "No fue posible consultar los productos."
          );
        }


        const html =
          await response.text();


        const parser =
          new DOMParser();


        const documentResult =
          parser.parseFromString(
            html,
            "text/html"
          );


        const resultsRoot =
          documentResult.querySelector(
            "[data-p-marcas-results]"
          );


        if (!resultsRoot) {
          throw new Error(
            "Shopify no devolvió la sección de resultados esperada."
          );
        }


        const returnedItems =
          resultsRoot.querySelectorAll(
            ".p-marcas-item"
          );


        const returnedCount =
          returnedItems.length;


        const moreAvailable =
          resultsRoot.dataset.hasMore === "true";


        returnedItems.forEach(item => {

          productsContainer.appendChild(
            item.cloneNode(true)
          );

        });


        if (loading) {
          loading.hidden = true;
        }


        if (productsContainer.children.length > 0) {

          if (panel) {
            panel.hidden = false;
          }

          if (empty) {
            empty.hidden = true;
          }

        } else {

          if (panel) {
            panel.hidden = true;
          }

          if (empty) {
            empty.hidden = false;
          }

        }


        hasMore =
          returnedCount > 0 &&
          moreAvailable;


        if (loadMoreWrap) {

          loadMoreWrap.hidden =
            !hasMore;

        }


        if (hasMore) {
          currentPage++;
        }

      } catch (error) {

        console.error(
          "ApoloPets P. Marcas:",
          error
        );


        if (loading) {
          loading.hidden = true;
        }


        if (
          productsContainer.children.length === 0 &&
          empty
        ) {
          empty.hidden = false;
        }


        if (loadMoreWrap) {
          loadMoreWrap.hidden = true;
        }

      } finally {

        isLoading = false;


        if (loadMoreButton) {
          loadMoreButton.disabled = false;
        }

      }

    }


    /* ======================================================
       VER MÁS
    ====================================================== */

    if (loadMoreButton) {

      loadMoreButton.addEventListener(
        "click",
        () => {
          loadProducts();
        }
      );

    }


    /* ======================================================
       CARGA INICIAL
    ====================================================== */

    loadProducts();

  });

});